import React, { lazy, useContext } from 'react';

import Loadable from './Loadable';
import AppContext from '@context';

import StepInitial from '@/features/Landing/step-initial/page/index';
import BannerContainer from '@/components/bannerContainer/index';
import ContainerComponents from '@/components/container/index';

import StepClient from '@/features/Landing/step-result-client/page';
import StepNoClient from '@/features/Landing/step-result-no-client/page';
import StepError from '@/features/Landing/step-error/page';

function filter_props(contextProps, filterModel) {

  if (!contextProps || !filterModel) {
    return;
  }

  let filterProps = contextProps.filter((o, i) => {
    return Object.keys(o)[0] === filterModel;
  });

  if (filterProps.length === 0) {
    return {};
  }
  filterProps = filterProps[0][filterModel];

  return filterProps.length !== 0 ? filterProps : {};
}

const ResponsiveGrid = props => props.children;

const ResponsiveGridTwo = (props) => {
  return (
    <>
      <BannerContainer authoring = {props.authoring}>
        {props.children}
      </BannerContainer>
    </>
  );
};

const ResponsiveGridThree = (props) => {
  return (
    <>
      <ContainerComponents authoring = {props.authoring}>
        {props.children}
      </ContainerComponents>
    </>
  );
};

const KeysToComponentMap = {
  root: ResponsiveGrid,
  responsivegrid: ResponsiveGrid,
  banner_container: ResponsiveGridTwo,
  container: ResponsiveGridThree,
  step_initial: StepInitial,
  step_client: StepClient,
  step_no_client: StepNoClient,
  step_error: StepError
};

function createComponent(type) {
  return React.createElement(
    KeysToComponentMap[type.component],
    type.props,
    type?.children && typeof type?.children === 'string'
      ? type?.children
      : type?.children.map((children) => renderer(children))
  );
}

function renderer(type) {
  if (typeof type.children === 'undefined') {
    type.children = [];
  }
  if (typeof KeysToComponentMap[type.component] !== 'undefined') {
    return typeof type.gridClassNames !== 'undefined' ? 
      <div className={type.gridClassNames}>{createComponent(type)}</div> : 
      createComponent(type)
  }
}

const FindModel = (type) => {
  const contextValue = useContext(AppContext);

  if (typeof filter_props(contextValue, type) === 'undefined') {
    return <></>;
  }
  return renderer(filter_props(contextValue, type));
}

export default FindModel;

